import { Injectable } from '@angular/core';
import { ID } from '@common/interfaces/id';
import { IID_FEASABILITY_REQUEST_IDENTIFIER } from "@common/interfaces/interfaceData";
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
import { Topics } from '@common/interfaces/topics';
import { EntityState, EntityStore } from '@datorama/akita';
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { InterfaceDataStore } from '../interfaceDataRegistry';

export interface StudioFattibilitaRequestState extends EntityState<IID_FEASABILITY_REQUEST_IDENTIFIER, ID> {}

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_FEASABILITY_REQUEST_IDENTIFIER , realtimeEntity: 'IID_FeasabilityRequestIdentifier'})
@InterfaceDataStore(InterfaceName.IID_FEASABILITY_REQUEST_IDENTIFIER)
export class StudioFattibilitaRequestStore extends EntityStore<StudioFattibilitaRequestState> {
  constructor() {
    super([]);
  }
}
